import React, { useState } from 'react';
import { InfoIcon, MinimizeIcon, MaximizeIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FloatingLegend: React.FC = () => {
  const [isMinimized, setIsMinimized] = useState(true);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="fixed bottom-4 right-4 bg-white rounded-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] border border-[#F2F3F5] max-w-xs" data-id="element-159" data-mp="10ic21824f92s">
      <div className={`p-4 ${isMinimized ? 'pb-3' : ''}`} data-id="element-160" data-mp="witiafm1d41j">
        <div className="flex items-start justify-between" data-id="element-161" data-mp="wkeba0spcexa">
          <AnimatePresence mode="wait" data-id="element-162" data-mp="hm2ii58g9qbe">
            {isMinimized ? <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="flex items-center space-x-2" data-id="element-163" data-mp="hnnc9smxx587">
                <InfoIcon className="h-4 w-4 text-[#D1005D] flex-shrink-0" data-id="element-164" data-mp="2bxqymaqf3yxd" />
                <span className="text-sm text-[#212326]" data-id="element-165" data-mp="2gxvga432azp6">95% Confidence</span>
              </motion.div> : <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="flex items-start space-x-3" data-id="element-166" data-mp="1pbudpw7g0klk">
                <InfoIcon className="h-5 w-5 text-[#D1005D] flex-shrink-0 mt-0.5" data-id="element-167" data-mp="1z2oyew51jc4w" />
                <div data-id="element-168" data-mp="1u5gg8vjw783n">
                  <h4 className="font-medium text-[#141617] text-sm" data-id="element-169" data-mp="1u4x826k1ny2t">
                    95% Confidence Level
                  </h4>
                  <p className="text-xs text-[#707070] mt-1" data-id="element-170" data-mp="11fq06gyp9w4w">
                    Results at this level indicate very strong statistical
                    confidence in the findings.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
          <button onClick={() => setIsMinimized(!isMinimized)} className="ml-3 p-1 hover:bg-gray-100 rounded-full transition-colors" aria-label={isMinimized ? 'Show more details' : 'Show less details'} data-id="element-171" data-mp="1bg0ek4wh19ln">
            {isMinimized ? <MaximizeIcon className="h-4 w-4 text-[#707070]" data-id="element-172" data-mp="1ji5ioxh0tr8h" /> : <MinimizeIcon className="h-4 w-4 text-[#707070]" data-id="element-173" data-mp="1jhdqlwmmubmy" />}
          </button>
        </div>
      </div>
    </motion.div>;
};